var map = {
	"./images/123.png": "96f6",
	"./images/31.png": "0512c",
	"./images/401.png": "7ce4",
	"./images/404.png": "3dfc",
	"./images/agency/side/agency-project-active.png": "b504",
	"./images/agency/side/agency-project.png": "9348",
	"./images/agency/side/entrust-active.png": "26b73",
	"./images/agency/side/entrust.png": "02ca",
	"./images/alipay-active.png": "147d",
	"./images/alipay-example.png": "4578",
	"./images/alipay.png": "d342",
	"./images/ca/authorization.png": "e464",
	"./images/ca/common/bid-tool.png": "1c82",
	"./images/ca/common/ca-flow.png": "3c44",
	"./images/ca/common/is-active.png": "4ba7",
	"./images/ca/common/m-key.png": "b0be",
	"./images/ca/common/mkey-scan.png": "8d2b",
	"./images/ca/common/prod-mkey-qrcode.png": "4f73",
	"./images/ca/common/test-mkey-qrcode.png": "7cc3",
	"./images/ca/common/u-key.png": "7e67",
	"./images/ca/side/app-tool-active.png": "de68",
	"./images/ca/side/app-tool.png": "44ba",
	"./images/ca/side/buy-active.png": "82a4f",
	"./images/ca/side/buy.png": "f92a",
	"./images/ca/side/fqa-active.png": "67ca",
	"./images/ca/side/fqa.png": "e284",
	"./images/ca/side/personal-active.png": "02d2",
	"./images/ca/side/personal.png": "18e2",
	"./images/ca/vip-home/empty-follow-company.png": "bd56",
	"./images/ca/vip-home/empty-follow-project.png": "8890",
	"./images/ca/vip-home/empty-subscription.png": "5d0f",
	"./images/ca/vip-home/icon-bid_analysis.png": "b599",
	"./images/ca/vip-home/icon-bid_file_analysis.png": "6ddb",
	"./images/ca/vip-home/icon-bid_file_preview-active.png": "b881",
	"./images/ca/vip-home/icon-bid_file_preview.png": "d8dd",
	"./images/ca/vip-home/icon-biddog_library.png": "d53b",
	"./images/ca/vip-home/icon-company_portrait-active.png": "d553",
	"./images/ca/vip-home/icon-company_portrait.png": "38d8",
	"./images/ca/vip-home/icon-competitor_analysis.png": "2696",
	"./images/ca/vip-home/icon-consultant-active.png": "95cc",
	"./images/ca/vip-home/icon-consultant.png": "79b5",
	"./images/ca/vip-home/icon-custom_data.png": "e418",
	"./images/ca/vip-home/icon-customer-service.png": "5e85",
	"./images/ca/vip-home/icon-digital_certificate_voucher-active.png": "7b12",
	"./images/ca/vip-home/icon-digital_certificate_voucher.png": "5e6b",
	"./images/ca/vip-home/icon-esign_voucher-active.png": "ec2f",
	"./images/ca/vip-home/icon-esign_voucher.png": "2504",
	"./images/ca/vip-home/icon-follow.png": "1b0c",
	"./images/ca/vip-home/icon-follow_company-active.png": "1822",
	"./images/ca/vip-home/icon-follow_company.png": "0693",
	"./images/ca/vip-home/icon-follow_project-active.png": "ae10",
	"./images/ca/vip-home/icon-follow_project.png": "abe0",
	"./images/ca/vip-home/icon-lock.png": "3de3",
	"./images/ca/vip-home/icon-mark_subscribe-active.png": "30f6",
	"./images/ca/vip-home/icon-mark_subscribe.png": "bc74",
	"./images/ca/vip-home/icon-notice_export-active.png": "c420",
	"./images/ca/vip-home/icon-notice_export.png": "d634",
	"./images/ca/vip-home/icon-notice_search.png": "8b66",
	"./images/ca/vip-home/icon-purchaser_analysis.png": "c334",
	"./images/ca/vip-home/icon-subscription.png": "fd86",
	"./images/ca/vip-home/vip-banner-advanced.png": "3697",
	"./images/ca/vip-home/vip-banner-diamond.png": "693e",
	"./images/ca/vip-home/vip-banner-regular.png": "22b0",
	"./images/ca/vip-home/vip-banner.png": "f563",
	"./images/ca/vip-home/vip-guarantee-ad.png": "cfd3",
	"./images/ca/vip-home/vip-guarantee-fee-background.png": "f138",
	"./images/ca/vip-home/vip-guarantee-fee-title-icon.png": "16a9",
	"./images/ca/vip-home/vip-tag-advanced.png": "c85e",
	"./images/ca/vip-home/vip-tag-diamond.png": "ac118",
	"./images/ca/vip-home/vip-tag-regular.png": "69ae",
	"./images/ca/vip-icon.png": "3670",
	"./images/ca/vip-promotion-banner.png": "0770",
	"./images/caigouren.png": "b541",
	"./images/caozuo.png": "d328",
	"./images/default-avatar.png": "4294",
	"./images/delete.png": "b32a",
	"./images/djscd.png": "9c78",
	"./images/download.png": "96fc",
	"./images/empty/hide-apply.png": "a98d",
	"./images/empty/list_no_content.png": "425f",
	"./images/empty/no-content-1.png": "e698",
	"./images/empty/no-content.png": "9867",
	"./images/enterprise/homepage/department.png": "1cc7",
	"./images/enterprise/homepage/info.png": "6de6",
	"./images/enterprise/homepage/portal.png": "8e07",
	"./images/enterprise/homepage/user.png": "6282",
	"./images/enterprise/side/app-active.png": "de5b",
	"./images/enterprise/side/app.png": "b8ec",
	"./images/enterprise/side/certificate-active.png": "5177",
	"./images/enterprise/side/certificate.png": "31e5",
	"./images/enterprise/side/department-icon-active.png": "4bc0",
	"./images/enterprise/side/department-icon.png": "d8da",
	"./images/enterprise/side/employee-icon-active.png": "ff2d",
	"./images/enterprise/side/employee-icon.png": "f8ff",
	"./images/enterprise/side/home-active.png": "308b",
	"./images/enterprise/side/home.png": "1c12",
	"./images/enterprise/side/info-icon-active.png": "5486",
	"./images/enterprise/side/info-icon.png": "7ce7",
	"./images/enterprise/side/portal-icon-active.png": "9a2e",
	"./images/enterprise/side/portal-icon.png": "a3e62",
	"./images/enterprise/side/template.png": "c9e2",
	"./images/enterprise/side/template_active.png": "696b",
	"./images/enterprise/side/workflow-active.png": "b2f3",
	"./images/enterprise/side/workflow.png": "09d2",
	"./images/expert/side/audit-active.png": "8a38",
	"./images/expert/side/audit.png": "ba48",
	"./images/expert/side/extract-active.png": "f363",
	"./images/expert/side/extract.png": "dcf3",
	"./images/expert/side/major-active.png": "b71a",
	"./images/expert/side/major.png": "dd72",
	"./images/expert/side/person-active.png": "26af",
	"./images/expert/side/person.png": "21aa",
	"./images/fail-img.png": "72df",
	"./images/fail.png": "91c3",
	"./images/financial/common/account-balance-icon.png": "9c9f",
	"./images/financial/common/account-withdrawn-icon.png": "a756",
	"./images/financial/common/primary-bg-bar.png": "d183",
	"./images/financial/side/account-active.png": "135f",
	"./images/financial/side/account.png": "4e20",
	"./images/financial/side/invoice-active.png": "4eaa",
	"./images/financial/side/invoice.png": "eb1e",
	"./images/financial/side/revenue-active.png": "ef18",
	"./images/financial/side/revenue.png": "5299",
	"./images/gzw-logo.png": "7af0",
	"./images/hall/bid-open-hall-body.png": "197c",
	"./images/hall/bid-open-hall-center-border.png": "7cd3",
	"./images/hall/bid-open-hall-head-light.png": "e07b",
	"./images/hall/bid-open-hall-head.png": "0138",
	"./images/hall/bid-open-hall-left.png": "b2aa",
	"./images/hall/bid-open-hall-right.png": "14f0",
	"./images/hall/file-back.png": "9ed7",
	"./images/hall/lock-decode.png": "e510",
	"./images/hall/lock-un-decode.png": "d93c",
	"./images/hall/open-bid-end.png": "c1f97",
	"./images/hall/qr-ca.png": "3245",
	"./images/hall/ukey-ca.png": "f355",
	"./images/hall/ukey-check.gif": "4097",
	"./images/hall/ukey-success.png": "679e",
	"./images/home-page/agency-active.svg": "2a4d",
	"./images/home-page/agency.svg": "1e58",
	"./images/home-page/purchaser-active.svg": "0376",
	"./images/home-page/purchaser.svg": "90ce6",
	"./images/home-page/supplier-active.svg": "ae21",
	"./images/home-page/supplier.svg": "c6c4",
	"./images/home/MembershipService/competitor.png": "dcc1",
	"./images/home/MembershipService/custom-data.png": "2edd",
	"./images/home/MembershipService/follow.png": "a593",
	"./images/home/MembershipService/invite-tenders.png": "7675",
	"./images/home/MembershipService/library.png": "f2d6",
	"./images/home/MembershipService/notice.png": "c98b",
	"./images/home/MembershipService/purchaser.png": "fd61",
	"./images/home/MembershipService/subscription.png": "dd87",
	"./images/home/MembershipService/tender.png": "78ef",
	"./images/home/Notice-no-data.png": "22e2",
	"./images/home/Project-no-data.png": "3224",
	"./images/home/SystemInformation-no-data.png": "6601",
	"./images/home/ToDoList-no-data.png": "bbe8",
	"./images/home/User/agency-open.png": "d659",
	"./images/home/User/agency-vip-bg.png": "e826",
	"./images/home/User/agency-vip.png": "fe1d",
	"./images/home/User/agency.png": "dfc7",
	"./images/home/User/avatar.png": "7440",
	"./images/home/User/basic.png": "fdb2",
	"./images/home/User/basic1.png": "ad87",
	"./images/home/User/basic2.png": "b524",
	"./images/home/User/basic3.png": "4d2b",
	"./images/home/User/basic4.png": "dc72",
	"./images/home/User/basic5.png": "df49",
	"./images/home/User/basic6.png": "717e",
	"./images/home/User/basic7.png": "88f2",
	"./images/home/User/basic8.png": "f12e",
	"./images/home/User/diamond.png": "71f3",
	"./images/home/User/diamond1.png": "337b",
	"./images/home/User/diamond2.png": "91654",
	"./images/home/User/diamond3.png": "29e3",
	"./images/home/User/diamond4.png": "92a4",
	"./images/home/User/diamond5.png": "87bf",
	"./images/home/User/diamond6.png": "9961",
	"./images/home/User/diamond7.png": "af19",
	"./images/home/User/diamond8.png": "efa8",
	"./images/home/User/premium.png": "6e19",
	"./images/home/User/premium1.png": "62db",
	"./images/home/User/premium2.png": "da06",
	"./images/home/User/premium3.png": "516e",
	"./images/home/User/premium4.png": "7685",
	"./images/home/User/premium5.png": "93b7",
	"./images/home/User/premium6.png": "67b9",
	"./images/home/User/premium7.png": "697a",
	"./images/home/User/premium8.png": "ccc7",
	"./images/home/User/purchase-open.png": "79d5",
	"./images/home/User/purchase.png": "c10f",
	"./images/home/User/supplier-basic-vip-bg.png": "9bd3",
	"./images/home/User/supplier-diamond-vip-bg.png": "1e7c",
	"./images/home/User/supplier-no-vip-bg.png": "975b",
	"./images/home/User/supplier-open.png": "3e77",
	"./images/home/User/supplier-premium-vip-bg.png": "cebd",
	"./images/home/User/supplier.png": "ca3c",
	"./images/home/no-cert.png": "df37",
	"./images/import.png": "9402",
	"./images/kpgl01.png": "ea29",
	"./images/kpgl02.png": "43ca",
	"./images/lock.png": "4f99",
	"./images/logo.png": "9d64",
	"./images/no-content.png": "107e",
	"./images/no-pass.png": "ebdc",
	"./images/order/side/order-active.png": "4992",
	"./images/order/side/order.png": "8be4",
	"./images/pass-loading.png": "164b",
	"./images/pass-pending.png": "2cd0",
	"./images/pass.png": "0c377",
	"./images/pay-center-logo.png": "9030",
	"./images/pay-center-top.png": "0671",
	"./images/pay-result-success.png": "9c96",
	"./images/pending-pay.png": "276b",
	"./images/pending.png": "1a0d",
	"./images/purchase-demand/side/apply-active.png": "682a",
	"./images/purchase-demand/side/apply-distribution-active.png": "afd0",
	"./images/purchase-demand/side/apply-distribution.png": "863c",
	"./images/purchase-demand/side/apply-handle-active.png": "f451",
	"./images/purchase-demand/side/apply-handle.png": "e0fa",
	"./images/purchase-demand/side/apply.png": "7073",
	"./images/purchase-demand/side/plan-active.png": "0a70",
	"./images/purchase-demand/side/plan.png": "c451",
	"./images/purchaser/inquiry/icon-excel.png": "1447",
	"./images/purchaser/inquiry/icon-file-box.png": "7463",
	"./images/purchaser/side/bidding-active.png": "e776",
	"./images/purchaser/side/bidding.png": "5046",
	"./images/purchaser/side/compete-active.png": "e8c9",
	"./images/purchaser/side/compete.png": "cc09",
	"./images/purchaser/side/demand-active.png": "1057",
	"./images/purchaser/side/demand.png": "79fd",
	"./images/purchaser/side/entrust-active.png": "d152",
	"./images/purchaser/side/entrust.png": "5b3e",
	"./images/purchaser/side/inquiry-active.png": "80f7",
	"./images/purchaser/side/inquiry.png": "ff9e",
	"./images/purchaser/side/negotiation-active.png": "8f38",
	"./images/purchaser/side/negotiation.png": "efb7",
	"./images/purchaser/side/record-active.png": "4501",
	"./images/purchaser/side/record.png": "9e38",
	"./images/qiyetouxiang.png": "7b74",
	"./images/qsrmm.png": "67f1",
	"./images/query-stats/jxic-icon.png": "4722",
	"./images/query-stats/side/agency-active.png": "bfbb",
	"./images/query-stats/side/agency.png": "1c04",
	"./images/query-stats/side/deal-supplier-active.png": "2b66",
	"./images/query-stats/side/deal-supplier.png": "f6d9",
	"./images/query-stats/side/item-price-library-active.png": "deee",
	"./images/query-stats/side/item-price-library.png": "b140",
	"./images/query-stats/side/purchaser-active.png": "5910",
	"./images/query-stats/side/purchaser.png": "cd0b",
	"./images/query-stats/side/statistic-active.png": "ab92",
	"./images/query-stats/side/statistic.png": "1307",
	"./images/query-stats/side/supplier-trade-statistic-active.png": "9b62",
	"./images/query-stats/side/supplier-trade-statistic.png": "a678",
	"./images/query-stats/side/tender-fee-active.png": "b477",
	"./images/query-stats/side/tender-fee.png": "acc6",
	"./images/qyzlwws.png": "16b6",
	"./images/review-hall/chat-default-image.png": "a8c2",
	"./images/review-hall/quote-default-image.png": "fad3",
	"./images/review-hall/report-default-image.png": "75d1",
	"./images/review-hall/report-word-closed.png": "d294",
	"./images/review-hall/report-word.png": "4dfae",
	"./images/review-hall/summary-default-image.png": "ac79",
	"./images/risk/card-icon1.png": "b0fb",
	"./images/risk/card-icon2.png": "9a97",
	"./images/risk/card-icon3.png": "fc7d",
	"./images/risk/card-icon4.png": "1681",
	"./images/risk/card-icon5.png": "c213",
	"./images/risk/statistics-icon1.png": "1a84",
	"./images/risk/statistics-icon2.png": "690d",
	"./images/risk/statistics-icon3.png": "a828",
	"./images/risk/statistics-icon4.png": "34d8",
	"./images/select-company/background.png": "faf6",
	"./images/service/agency-icon.png": "2307",
	"./images/service/purchaser-icon.png": "bc5c",
	"./images/service/supplier-icon.png": "d90f",
	"./images/sftb.png": "eac52",
	"./images/signature/excel-icon.png": "6099",
	"./images/signature/excel-operation.png": "4bda",
	"./images/supplier-management/side/agreement-active.png": "d7b6",
	"./images/supplier-management/side/agreement.png": "87f7",
	"./images/supplier-management/side/recruit-active.png": "1dbd",
	"./images/supplier-management/side/recruit.png": "2655",
	"./images/supplier-management/side/supplier-lib-active.png": "5e1d",
	"./images/supplier-management/side/supplier-lib.png": "ea6a",
	"./images/supplier/bid-dog/img1.png": "2587",
	"./images/supplier/bid-dog/img2.png": "7b8c",
	"./images/supplier/bid/finance-customer.png": "c55c",
	"./images/supplier/guarantee-pre-save/network-notice-banner.png": "31a0",
	"./images/supplier/guarantee-pre-save/pre-save-open-tip.png": "1dc0",
	"./images/supplier/guarantee-pre-save/publicity-1.png": "8e87",
	"./images/supplier/guarantee-pre-save/publicity-2.png": "ba1c",
	"./images/supplier/guarantee-pre-save/publicity-3.png": "5d22",
	"./images/supplier/guarantee-pre-save/publicity-4.png": "61c5",
	"./images/supplier/guarantee-pre-save/service-icon-card.png": "a5c1",
	"./images/supplier/guarantee-pre-save/service-icon-round.png": "00ec",
	"./images/supplier/guarantee-pre-save/title-icon.png": "1608",
	"./images/supplier/side/invitation-active.png": "8781",
	"./images/supplier/side/invitation.png": "bffc",
	"./images/supplier/side/involved-project-active.png": "eb6a",
	"./images/supplier/side/involved-project.png": "b62c",
	"./images/supplier/side/notice-search-active.png": "1af1",
	"./images/supplier/side/notice-search.png": "229c",
	"./images/supplier/side/order-coordination-active.png": "2d43",
	"./images/supplier/side/order-coordination.png": "172dc",
	"./images/tjcg.png": "74a8",
	"./images/value-added/competitor-analysis-banner.png": "03fe",
	"./images/value-added/network-notice-banner.png": "a9bd",
	"./images/value-added/purchaser-analysis-banner.png": "1b93",
	"./images/value-added/vip-open-tip.png": "63883",
	"./images/wechat-pay-active.png": "32c1",
	"./images/wechat-pay-example.png": "df78",
	"./images/wechat-pay.png": "f0a9",
	"./images/xxzx.png": "bb7b",
	"./images/yichang.png": "3c65",
	"./images/zanwuxiangguanshuju.png": "4552"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "216e";